import { IDecisionAct } from 'APIPackage/DecisionModule/interfaces/IDecisionAct';
import { convertFormDateTimeValueToKnmDataDate } from 'KnmPackage/MainModule/common/convertFormDateTimeValueToKnmDataDate';
import { convertKnmDocumentAttachmentsFormValuesToKnmData } from 'KnmPackage/MainModule/common/convertKnmDocumentAttachmentsFormValuesToKnmData';
import { convertInspectorsFormValuesToKnmData } from 'KnmErknmPackage/MainModule/common/convertInspectorsFormValuesToKnmData';
import { convertViolatedRequirementsFormValuesToKnmData } from 'KnmErknmPackage/MainModule/common/convertViolatedRequirementsFormValuesToKnmData';
import { IKnmActFamiliarizationNotifications } from 'APIPackage/KnmModule/interfaces/IKnmActFamiliarizationNotifications';
import { convertFormDateValueToKnmDataDate } from 'KnmPackage/MainModule/common/convertFormDateValueToKnmDataDate';
import { getIntNumberByString } from 'CorePackage/MainModule/common/getIntNumberByString';
import { getDirtyActGuid } from 'CorePackage/HeaderModule/reducers/headerReducer';
import { store } from 'CorePackage/MainModule/common/store';
import { convertActRemarksFormToData } from 'KnmErknmPackage/MainModule/common/convertActRemarksFormToData';
import { convertEventsFormValuesToKnmData } from 'KnmErknmPackage/MainModule/common/convertEventsFormValuesToKnmData';

import { IDecisionActForm } from '../interfaces/IDecisionActForm';
import { convertSignersFormToData } from '../../../KnmErknmPackage/MainModule/common/convertSignersFormToData';
import { convertViolationEvidencesFormValuesToVideoFixations } from './convertDecisionVideoFixations';

export const convertDecisionActFormValuesToData = (
  act: IDecisionActForm,
  isDraft: boolean | undefined,
): IDecisionAct => {
  const state = store.getState();
  const dirtyActGuid = getDirtyActGuid(state);

  return {
    isNew: isDraft ? act.isNew : null,
    created: act.created || null,
    creationActDateTime: act.paperless
      ? act.creationActDateTime || null
      : convertFormDateTimeValueToKnmDataDate(act.creationActDateTime, false),
    signActDateTime: act.signActDateTime || null,
    document: act.document
      ? {
          active: act.document.active || null,
          attachments: convertKnmDocumentAttachmentsFormValuesToKnmData(act.document.attachments),
          correlationToken: act.document.correlationToken || null,
          description: act.document.description || null,
          guid: act.document.guid || null,
          type: act.document.type || null,
        }
      : null,
    guid: act.guid || null,
    nextWordDayActDateTime: act.nextWordDayActDateTime || null,
    numberAct: act.numberAct || null,
    signed: dirtyActGuid && dirtyActGuid === act.guid ? false : act.signed ?? null,
    paperless: act.paperless || null,
    extractVersion: act.extractVersion || null,
    isViolations:
      typeof act.isViolatedMandatoryRequirements?.value === 'boolean'
        ? act.isViolatedMandatoryRequirements.value
        : null,
    violations: convertViolatedRequirementsFormValuesToKnmData(act.violatedMandatoryRequirements),
    videoFixationsCheckbox:
      typeof act.isViolationEvidenceExists?.value === 'boolean' ? act.isViolationEvidenceExists.value : null,
    videoFixations: convertViolationEvidencesFormValuesToVideoFixations(act?.violationEvidences),
    familiarizationNotifications:
      act?.familiarizationNotifications?.map(x => {
        const notification: IKnmActFamiliarizationNotifications = {
          noticeDate: convertFormDateValueToKnmDataDate(x.noticeDate),
          knmNoticeType: x.knmNoticeType || null,
          note: x.note || null,
          guid: x.listId,
          isNew: x.isNew,
          existedAtSigning: x.existedAtSigning || null,
        };

        return notification;
      }) || null,
    remarks: convertActRemarksFormToData(act.remarks),
    events: convertEventsFormValuesToKnmData(act.events, undefined, undefined, isDraft),
    holdingDateTime: convertFormDateTimeValueToKnmDataDate(act.holdingDateTime),
    durationDays: getIntNumberByString(act?.durationDays),
    durationHours: getIntNumberByString(act?.durationHours),
    knoInspectors: convertInspectorsFormValuesToKnmData(true, act.knoInspectors),
    involvedWitnesses: !act.involvedWitnesses
      ? null
      : act.involvedWitnesses.filter(i => i.fullName).map(i => ({ fullName: i.fullName || '', guid: i.listId })),
    titleSigner: act?.fioAndPositionSinger?.value.position?.value || null,
    fioSigner: act.fioAndPositionSinger?.value.fullName || null,
    noteInvalidate: act.noteInvalidate || null,
    fileInvalidate: convertKnmDocumentAttachmentsFormValuesToKnmData([act.fileInvalidate])?.pop() || null,
    officialFullNameCancel: act.officialFullNameCancel || null,
    resultContentPositionCancel: !act.resultContentPositionCancel ? null : act.resultContentPositionCancel.value,
    firstExtractDateTime: convertFormDateTimeValueToKnmDataDate(act.firstExtractDateTime, false) || null,
    systemSignatureDateTime: act.systemSignatureDateTime,
    systemSignatureMnemonic: act.systemSignatureMnemonic,
    systemSignatureTitle: act.systemSignatureTitle,
    systemSignatureUsed: act.systemSignatureUsed,
    signers: convertSignersFormToData(act.signers),
  };
};
